/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SiteNavFullWidthDropdownContent_navigationModule = {|
  +imageUrl: ?string;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SiteNavFullWidthDropdownContent_navigationModule",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SiteNavDropdownImageModule_navigationModule",
      "args": null
    }
  ],
  "type": "NavigationModule"
};

module.exports = fragment;
